// src/pages/KelurahanForm.jsx

import React, { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import {
  Modal,
  TextInput,
  Button,
  LoadingOverlay,
  Alert,
  Group,
} from "@mantine/core";
import api from "../../services/api";

/**
 * Props:
 * - opened: boolean
 * - onClose: function
 * - onSuccess: function
 * - kelurahan: object (
 * - Saat Edit: Berisi data { id, nama_kelurahan, kecamatan_id }
 * - Saat Tambah: Berisi { kecamatan_id } (dari parent)
 * )
 */
export default function KelurahanForm({ opened, onClose, onSuccess, kelurahan }) {
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState(null);
  
  const isEdit = Boolean(kelurahan && kelurahan.id); 

  const form = useForm({
    initialValues: {
      nama_kelurahan: "",
      kecamatan_id: null,
    },
    validate: {
      nama_kelurahan: (val) => (val.trim().length === 0 ? "Nama kelurahan tidak boleh kosong" : null),
      kecamatan_id: (val) => (val === null ? "Kecamatan ID tidak boleh kosong" : null),
    },
  });

  // Isi form saat modal dibuka
  useEffect(() => {
    if (opened) {
      if (isEdit) {
        // Mode Edit
        form.setValues({
          nama_kelurahan: kelurahan.nama_kelurahan,
          kecamatan_id: kelurahan.kecamatan_id,
        });
      } else {
        // Mode Tambah
        form.setValues({
          nama_kelurahan: "",
          kecamatan_id: kelurahan?.kecamatan_id, // Ambil 'kecamatan_id' dari parent
        });
      }
    }
  }, [kelurahan, opened]);

  const handleClose = () => {
    form.reset();
    setFormError(null);
    onClose();
  };

  // Fungsi saat tombol "Simpan" (submit) ditekan
  const handleSubmit = async (values) => {
    setLoading(true);
    setFormError(null);
    
    try {
      if (isEdit) {
        // Panggil API 'updateKelurahan'
        await api.put(`/admin/kelurahan/${kelurahan.id}`, values);
      } else {
        // Panggil API 'storeKelurahan'
        await api.post("/admin/kelurahan", values);
      }
      
      onSuccess(); // Panggil callback sukses (untuk refresh tabel)
      handleClose(); // Tutup modal

    } catch (err) {
      if (err.response && err.response.status === 422) {
        setFormError(Object.values(err.response.data.errors).flat().join(", "));
      } else {
        setFormError("Gagal menyimpan data. Coba lagi.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={isEdit ? "Edit Kelurahan" : "Tambah Kelurahan Baru"}
      size="md"
      overlayProps={{ blur: 2 }}
    >
      <LoadingOverlay visible={loading} />
      <form onSubmit={form.onSubmit(handleSubmit)}>
        
        {formError && (
          <Alert color="red" title="Error" withCloseButton onClose={() => setFormError(null)} mb="md">
            {formError}
          </Alert>
        )}
        
        <TextInput
          label="Nama Kelurahan"
          placeholder="Contoh: Sempur"
          {...form.getInputProps("nama_kelurahan")}
          required
        />
        
        {/* 'kecamatan_id' disembunyikan, tapi nilainya ada di form state */}

        <Group justify="flex-end" mt="xl">
          <Button variant="default" onClick={handleClose}>
            Batal
          </Button>
          <Button type="submit" loading={loading}>
            Simpan
          </Button>
        </Group>
      </form>
    </Modal>
  );
}